module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vabdo2-3194a1882ba6debd7e3dfe79395fe8bd.jpg";